import { coreInstance, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    roleData: null,
    servicesData: []
  },
  mutations: {
    getData(state, data) {
      state.roleData = data;
    },
    getServices(state, data) {
      state.servicesData = data;
    },
    clearServices(state) {
      state.servicesData = null;
    },
    addRole(state, data) {
      state.roleData.push(data);
    }
  },
  actions: {
    getData({ commit, state, dispatch }) {
      // coreInstance.get(backendVersion.version + "/roles");
    },
    getServices({ commit, dispatch }) {
      // coreInstance.get(backendVersion.version + "/services_permissions", axiosConfig);
    },
    addRole({ commit, dispatch }, data) {
      // coreInstance.post(backendVersion.version + "/create/role", data, axiosConfig);
    }
  },
  getters: {}
};
